import { Col, Row } from "@/components/customComponents";

import Pulse from "./Pulse";

const TAB_COUNT = 4;

const ChartSkeleton = () => (
  <Col className="gap-4">
    <Row className="items-center justify-between">
      <Pulse className="h-5 w-28" />
      <Row className="gap-1">
        {Array.from({ length: TAB_COUNT }).map((slot, i) => (
          <Pulse key={i} className="h-7 w-16 rounded-full" />
        ))}
      </Row>
    </Row>
    <div className="rounded-xl border border-default-200 bg-content1 p-4 dark:border-default-100">
      <Row className="mb-4 justify-center gap-4">
        <Pulse className="h-3 w-20" />
        <Pulse className="h-3 w-24" />
      </Row>
      <Pulse className="h-[280px] w-full rounded-lg" />
    </div>
  </Col>
);

export default ChartSkeleton;
